import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { NotificationType } from "../../../../../../apis/networkdashboard/graphql/graphql";
import { services } from "../../../../../../app/services";
import { FortiAnalyzerItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/forti-analyzer/forti-analyzer-item";
import { FortiManagerItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/forti-manager/forti-manager-item";
import { MalfunctionItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/malfunction/malfunction-item";
import { SendConfigItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/send-config/send-config-item";
import { ServiceDocumentationItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/service-documentation/service-documentation";
import { ShortcutMenu } from "../../../../../../components/subscription-detail/shortcut-menu/shortcut-menu";
import { ProductType } from "../../../../../../helpers/enums/productType";
import { FirewallSubscriptionDetails } from "../../../../../../pages/subscription-detail/types";

@Component({
  selector: "firewall-shortcut-menu",
  templateUrl: "firewall-shortcut-menu.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FortiAnalyzerItem,
    FortiManagerItem,
    MalfunctionItem,
    SendConfigItem,
    ServiceDocumentationItem,
    ShortcutMenu,
  ],
})
export class FirewallShortcutMenu {
  readonly subscription = input.required<FirewallSubscriptionDetails>();
  readonly activities = input.required<NotificationType[]>();
  protected readonly subscriptionId = computed(() => this.subscription().subscriptionId);

  protected readonly serviceDocumentationUrl = services[ProductType.Firewall].docs;
}
